export default __webpack_public_path__ + "static/media/check.7938ad2e.svg";